$(document).ready(function() {
    $(".jsLink").click(function(){
         window.location=$(this).find("a").attr("href");
         return false;
    });


    var didScroll;
    var lastScrollTop = 0;

     setInterval(function() {
         if (didScroll) {
             hasScrolled();
             didScroll = false;
         }
     }, 1000);

     $(window).scroll(function(event){
          didScroll = true;
     });

     function hasScrolled() {
         scroll = $( window ).height()/2;
         console.log(scroll);
         if($(this).scrollTop() > scroll){
             $('.arrow-up').addClass('active');
         }else{
             $('.arrow-up').removeClass('active');
         }
     }
     $('.arrow-up').click(function(e) {
         e.preventDefault();
         $('html, body').animate({scrollTop: 0}, 1000);
     });


     $('.jump-link').click(function(e) {
         e.preventDefault();
         $('html, body').animate({scrollTop: $($(this).attr('href')).offset().top - 140 }, 300);
     });

     $('#search a.close').click(function(e) {
         e.preventDefault();
         $('#search').removeClass('active');
     });
     $('#head a.search').click(function(e) {
         e.preventDefault();
         if($('#search').hasClass('active')){
              $('#search').removeClass('active');
         }else{
              $('#search').addClass('active');
         }

     });
});
